// src/pages/support/components/SwapMembersForm.jsx
import React, { useState } from "react";
import Field from "./Field";

function SwapMembersForm({ teams, onSubmit }) {
  const [firstTeamId, setFirstTeamId] = useState("");
  const [secondTeamId, setSecondTeamId] = useState("");
  const [firstTeamUserId, setFirstTeamUserId] = useState("");
  const [secondTeamUserId, setSecondTeamUserId] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  const firstTeam = teams.find((t) => String(t.id) === String(firstTeamId));
  const secondTeam = teams.find((t) => String(t.id) === String(secondTeamId));

  const firstTeamMembers = Array.isArray(firstTeam?.members) ? firstTeam.members : [];
  const secondTeamMembers = Array.isArray(secondTeam?.members) ? secondTeam.members : [];

  function validate() {
    if (!firstTeamId) return "انتخاب تیم اول الزامی است";
    if (!secondTeamId) return "انتخاب تیم دوم الزامی است";
    if (firstTeamId === secondTeamId) return "نمی‌توانید دو عضو از یک تیم را تعویض کنید";
    if (!firstTeamUserId) return "انتخاب بازیکن اول الزامی است";
    if (!secondTeamUserId) return "انتخاب بازیکن دوم الزامی است";
    return "";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validate();
    if (v) return setErr(v);
    setErr("");
    setSubmitting(true);
    try {
      await onSubmit(
        {
          first_team_id: Number(firstTeamId),
          second_team_id: Number(secondTeamId),
          first_team_user_id: Number(firstTeamUserId),
          second_team_user_id: Number(secondTeamUserId),
        },
        () => setSubmitting(false),
        (msg) => {
          setSubmitting(false);
          setErr(msg);
        }
      );
    } catch (e) {
      setSubmitting(false);
      setErr(e.message || "خطای نامشخص");
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 text-right">
      {err && <div className="text-red-400 text-sm">{err}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* تیم اول */}
        <div className="space-y-3">
          <div
            className="rounded-xl border p-3"
            style={{ borderColor: "rgba(59,130,246,0.4)", backgroundColor: "rgba(59,130,246,0.08)" }}
          >
            <h4 className="text-blue-400 font-semibold mb-2">تیم اول</h4>
            
            <Field label="انتخاب تیم اول">
              <select
                value={firstTeamId}
                onChange={(e) => {
                  setFirstTeamId(e.target.value);
                  setFirstTeamUserId("");
                }}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-blue-500"
              >
                <option value="">— انتخاب کنید —</option>
                {teams.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name} (اعضا: {Array.isArray(t.members) ? t.members.length : 0})
                  </option>
                ))}
              </select>
            </Field>

            <Field label="انتخاب بازیکن از تیم اول">
              <select
                value={firstTeamUserId}
                onChange={(e) => setFirstTeamUserId(e.target.value)}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-blue-500"
                disabled={!firstTeamId}
              >
                <option value="">— انتخاب کنید —</option>
                {firstTeamMembers.map((m) => {
                  const username = m?.user?.username || m?.user?.email || `User ${m.user_id}`;
                  const isCaptain = (m?.role || "").toLowerCase() === "captain";
                  return (
                    <option key={m.user_id} value={m.user_id}>
                      {username} {isCaptain ? "(کاپیتان)" : ""}
                    </option>
                  );
                })}
              </select>
            </Field>
          </div>
        </div>

        {/* تیم دوم */}
        <div className="space-y-3">
          <div
            className="rounded-xl border p-3"
            style={{ borderColor: "rgba(16,185,129,0.4)", backgroundColor: "rgba(16,185,129,0.08)" }}
          >
            <h4 className="text-emerald-400 font-semibold mb-2">تیم دوم</h4>
            
            <Field label="انتخاب تیم دوم">
              <select
                value={secondTeamId}
                onChange={(e) => {
                  setSecondTeamId(e.target.value);
                  setSecondTeamUserId("");
                }}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
              >
                <option value="">— انتخاب کنید —</option>
                {teams.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name} (اعضا: {Array.isArray(t.members) ? t.members.length : 0})
                  </option>
                ))}
              </select>
            </Field>

            <Field label="انتخاب بازیکن از تیم دوم">
              <select
                value={secondTeamUserId}
                onChange={(e) => setSecondTeamUserId(e.target.value)}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
                disabled={!secondTeamId}
              >
                <option value="">— انتخاب کنید —</option>
                {secondTeamMembers.map((m) => {
                  const username = m?.user?.username || m?.user?.email || `User ${m.user_id}`;
                  const isCaptain = (m?.role || "").toLowerCase() === "captain";
                  return (
                    <option key={m.user_id} value={m.user_id}>
                      {username} {isCaptain ? "(کاپیتان)" : ""}
                    </option>
                  );
                })}
              </select>
            </Field>
          </div>
        </div>
      </div>

      {/* نمایش خلاصه */}
      {firstTeamUserId && secondTeamUserId && (
        <div
          className="rounded-xl border p-4"
          style={{ borderColor: "rgba(245,158,11,0.4)", backgroundColor: "rgba(245,158,11,0.08)" }}
        >
          <p className="text-amber-300 text-sm">
            ✅ آماده تعویض:{" "}
            <span className="font-semibold">
              {firstTeamMembers.find((m) => String(m.user_id) === String(firstTeamUserId))?.user?.username || "بازیکن اول"}
            </span>
            {" ↔ "}
            <span className="font-semibold">
              {secondTeamMembers.find((m) => String(m.user_id) === String(secondTeamUserId))?.user?.username || "بازیکن دوم"}
            </span>
          </p>
        </div>
      )}

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="submit"
          disabled={submitting}
          className={`px-4 py-2 rounded-xl text-white ${submitting ? "opacity-70" : ""}`}
          style={{ backgroundColor: "#f59e0b" }}
        >
          {submitting ? "در حال تعویض..." : "🔄 تعویض اعضا"}
        </button>
      </div>
    </form>
  );
}

export default SwapMembersForm;